import { render } from "./menuItem.vue?vue&type=template&id=2e6c0b45"
import script from "./menuItem.vue?vue&type=script&lang=js"
export * from "./menuItem.vue?vue&type=script&lang=js"

import "./menuItem.vue?vue&type=style&index=0&id=2e6c0b45&lang=scss"

import exportComponent from "C:\\Users\\john doe\\Documents\\Venice\\vnc\\AgendaBuilder\\agenda\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__